import { memo } from 'react'

import type { IIconsProps } from './icons.types'

const IconTooltipPointRight = ({
  width = 6,
  height = 12,
  ...props
}: IIconsProps) => {
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 6 12'
      {...props}
    >
      <path
        d='M6 6V12L1.41421 7.41421C0.633165 6.63317 0.633165 5.36683 1.41421 4.58579L6 0V6Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default memo(IconTooltipPointRight)
